module.exports = __webpack_public_path__ + "static/media/backgroundMedium.47c0adaf.jpg";